<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>REPORT MANAGEMENT MODULE </h2>
       <p>Report Management List</p>
       </div>
      </div>
<div class="row">
<div class="col-lg-12 col-md-12 col-sm-12">
<ul class="ul_list">
  <li>MONTHLY CALCULATIONS  <a [routerLink]="['/dashboard','MonthlyCalculation']"  routerLinkActive="active-link"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
</li>
<li>MONTHLY CALCULATIONS - PERCENTAGE <a [routerLink]="['/dashboard','MonthlyCalculationPercentage']"  routerLinkActive="active-link"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
</li>
<li>CUMULATIVE AND ANNUAL CALCULATIONS <a [routerLink]="['/dashboard','CumulativeAndAnnualCalculation']"  routerLinkActive="active-link"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
</li>
<li *ngIf="hidden">COMPARISON OF ANNUAL CALCULATED VALUES FORM ALL FARMS <a [routerLink]="['/dashboard','ComparisonOfAnnualCalculation']"  routerLinkActive="active-link"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
</li>
<li *ngIf="hidden" >GENERATION OF OTHER GRAPHS <a [routerLink]="['/dashboard','GenerationOfGraphs']"  routerLinkActive="active-link"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
</li>
<li *ngIf="hidden">STOCK LEVEL DATABASE <a [routerLink]="['/dashboard','StockLevelDatabase']"  routerLinkActive="active-link"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
</li>
</ul>
</div>
       </div>
     </div>
   </div>
 </div>
